import _ from 'lodash';

const DiscountValidator = (props) => {
  const codeValidation = !!_.size(props.codes);
  const discountValue = !!_.size(props.discounts.toString());
  const usageLimit = props.usageLimitOn ? !!_.size(props.usageLimit) || props.usageLimit >= 0 : true;
  const perCheckoutLimit =
    props.perCheckoutLimitOn ? !!_.size(props.perCheckoutLimit) || props.perCheckoutLimit >= 0 : true;
  const expiredStart = props.expiredStartOn ? !!_.size(props.expiredStart) : true;
  const expiredEnd = props.expiredEndOn ? !!_.size(props.expiredEnd) : true;
  const appliedToTickets = props.applied_to_all_tickets ? true : !!_.size(props._applied_to_tickets);

  const requiredFields = [
    { value: appliedToTickets, key: 'appliedToTickets' },
    { value: codeValidation, key: 'codeValidation' },
    { value: discountValue, key: 'discountValue' },
    { value: usageLimit, key: 'usageLimit' },
    { value: perCheckoutLimit, key: 'perCheckoutLimit' },
    { value: expiredStart, key: 'expiredStart' },
    { value: expiredEnd, key: 'expiredEnd' }
  ];

  const result = _.compact(_.map(requiredFields, (rf) => {
    if (!rf.value) return rf.key;

    return null;
  }));

  return result;
};

export default DiscountValidator;

